import { render, staticRenderFns } from "./ConsultationHistory.vue?vue&type=template&id=156f647c&scoped=true&"
import script from "./ConsultationHistory.vue?vue&type=script&lang=js&"
export * from "./ConsultationHistory.vue?vue&type=script&lang=js&"
import style0 from "./ConsultationHistory.vue?vue&type=style&index=0&id=156f647c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156f647c",
  null
  
)

export default component.exports